module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            Add person\n        ")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addPerson()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.name),
      expression: "person.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-name"
    },
    domProps: {
      "value": (_vm.person.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.phone),
      expression: "person.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-phone"
    },
    domProps: {
      "value": (_vm.person.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "person-function"
    }
  }, [_vm._v("Function")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.function),
      expression: "person.function"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "person-function"
    },
    domProps: {
      "value": (_vm.person.function)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.function = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Add person\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4d0707e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/people/views/Create.vue
// module id = 109
// module chunks = 1